import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import PropTypes from "prop-types";
import renderCheckBoxField from "../../../shared/components/form/CheckBox";
import history from "../../../history";
import fakeAuth from "../../../auth";
import CommentAlertOutlineIcon from "mdi-react/CommentAlertOutlineIcon";
import validate from "./validate";
import { NavLink } from "react-router-dom";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import "moment/locale/es";
import { RegisterForm } from "../../Register/RegisterForm";

const renderField = ({
  input,
  placeholder,
  type,
  meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && (
      <span className="form__form-group-error">{error}</span>
    )}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: "",
  meta: null,
  type: "text",
};

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      username: "",
      password: "",
      check: false,
      error: "",
      reducers: {},
      reducer: null,
      store: null,
      options: null,
      openModal: null,
    };
  }

  handleUsername = (username) => {
    this.setState({ username: username });
  };

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handlePassword = (password) => {
    this.setState({ password: password });
  };

  rememberUser = (value) => {
    this.setState({ check: value });
  };

  fetchSendSubmit = () => {
    const hoy = new Date();
    var data = {
      username: this.state.username,
      password: this.state.password,
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);

        if (data.hasOwnProperty("token")) {
          this.setState({ error: "" });
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("usuario", JSON.stringify(data));
          this.getUser(data.usuario);
          fakeAuth.inactivityTime();
          fakeAuth.authenticate(() => {
            if (
              data.id_perfil == 16 ||
              data.id_perfil == 10 ||
              data.id_perfil == 20
            ) {
              history.replace({
                pathname:
                  process.env.PUBLIC_URL + "/assitencial/search-clinic-history",
                state: { date: moment(hoy).format("YYYY-MM-DD") },
              });
            } else {
              history.replace(process.env.PUBLIC_URL + "/pages/dashboard");
            }
          });
        } else {
          this.setState({ error: data.mensaje });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ error: error.message });
      });
  };

  getUser = (user) => {
    let data = {
      num_documento: "",
      nombres: "",
      apellido1: "",
      apellido2: "",
      usuario: user,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        sessionStorage.setItem("perfil", data.contenido[0].id_perfil);
        this.getProfile(data.contenido[0].id_perfil);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  getProfile = (id) => {
    let data = { id_perfil: id, nombre: "0" };

    fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        sessionStorage.setItem("nombreperfil", data.contenido[0].nombre);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleSubmit = () => {
    var values = {
      username: this.state.username,
      password: this.state.password,
    };
    var errors = validate(values);

    if (
      !errors.hasOwnProperty(values.username) &&
      !errors.hasOwnProperty(values.password)
    ) {
      this.fetchSendSubmit();
    }
  };

  handleModalRegister = () => {
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  handleOpenDocument = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_PUBLIC_URL +'manual-aplicativo/cargar-manual', {
        responseType: 'blob', 
      });

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, '_blank');
    
    } catch (error) {
      console.error("Error al cargar el manual:", error);
      alert("No se pudo cargar el manual en este momento.");
    }

  };

  render() {
    const { showPassword } = this.state;

    return (
      <>
        <form className="form">
          <div className="form__form-group">
            <span className="form__form-group-label">Correo electrónico</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <Field
                name="username"
                component={renderField}
                type="text"
                placeholder="Usuario"
                value={this.state.username}
                onChange={(e) => {
                  this.handleUsername(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Contraseña</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <Field
                name="password"
                component={renderField}
                type={showPassword ? "text" : "password"}
                placeholder="Contraseña"
                value={this.state.password}
                onChange={(e) => {
                  this.handlePassword(e.target.value);
                }}
              />
              <button
                className={`form__form-group-button${showPassword ? " active" : ""}`}
                onClick={(e) => this.showPassword(e)}
                type="button"
              >
                <EyeIcon />
              </button>
            </div>
            {/* <div className="account__forgot-password">
            <NavLink to={`${process.env.PUBLIC_URL}/reset_password`}>¿Desea recuperar contraseña?</NavLink>
          </div> */}
          </div>
          <div className="form__form-group" style={{ marginBottom: 0 }}>
            <div className="form__form-group-field">
              <Field
                name="remember_me"
                component={renderCheckBoxField}
                onChange={(e) => {
                  this.rememberUser(!this.state.check);
                }}
                checked={this.state.check}
                label="Recuerda me"
              />
            </div>
          </div>
          {this.state.error !== "" ? (
            <div style={{ display: "flex" }}>
              <div style={{ marginRight: 5 }}>
                <CommentAlertOutlineIcon color="red" />
              </div>
              <p
                style={{
                  height: 20,
                  width: "100%",
                  margin: 0,
                  marginBottom: 10,
                  color: "red",
                }}
              >
                <b>error:</b> {this.state.error}
              </p>
            </div>
          ) : (
            <p
              style={{ height: 20, width: "100%", margin: 0, marginBottom: 10 }}
            ></p>
          )}
          <button
            className="btn btn-primary account__btn account__btn--small"
            onClick={(e) => {
              e.preventDefault();
              this.handleSubmit();
            }}
          >
            Iniciar Sesión
          </button>
          <button
            className="btn btn-fourth account__btn account__btn--small"
            onClick={(e) => {
              e.preventDefault();
              this.handleModalRegister();
            }}
          >
            Crear cuenta
          </button>
          <button
            className="btn btn-third account__btn account__btn--small"
            onClick={(e) => {
              e.preventDefault();
              this.handleOpenDocument();
            }}
          >
            Como crear mi cuenta
          </button>
          {/*         <NavLink
          className="btn btn-primary account__btn account__btn--small"
          to={`${process.env.PUBLIC_URL}/register`}
          style={{ textAlign: "center", display: "block" }}
        >
          Crear cuenta
        </NavLink> */}
        </form>
        {this.state.openModal && (
          <RegisterForm
            openModal={this.state.openModal}
            handleCloseModal={this.handleCloseModal}
          />
        )}
      </>
    );
  }
}

export default reduxForm({
  form: "log_in_form",
  validate,
})(LogInForm);
